/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import WeekendIcon from "@mui/icons-material/Weekend";
import NotFound from "./Pages/notFound/NotFound";
import LoginComponnent from "./Pages/login";
import { useNavigate } from "react-router-dom";
import { WarningToaast } from "./utils/toast/Toast";
import { useEffect } from "react";
import KeyboardIcon from "@mui/icons-material/Keyboard";
import ParametrsPage from "./Pages/Parametrs";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import BankPage from "./Pages/Banks";
import AddOrEditBanks from "./Pages/Banks/AddOrEdit";
import Ghabz from "./Pages/Ghabz";
import PrintHtml from "./Pages/PrintHtml";
import Subscribers from "./Pages/Subscriber";
import SubscribersDetail from "./Pages/Subscriber/components/layouts/SubscribersDetail";
import { eraseCookie } from "./utils/tools/CookieManager";
import MainPage from "./Pages/MainPage";
import GhabzList from "./Pages/GhabzList";
import EditGhabz from "./Pages/GhabzList/EditGhabz/EditGhabz";
import MelkMalek from "./Pages/MelkMalek";
import AvarezNosazi from "./Pages/AvarezNosazi";
import MalekSenf from "./Pages/maleksenf";
import Asnaf from "./Pages/Asnaf";
import AvarezSenf from "./Pages/AvarezSenf";
import GozareshKoliAsnaf from "./Pages/GozareshKoli";
import GheymatManteghei from "./Pages/GheymatManteghei";
import Vehicles from "./Pages/Vehicles";
import AvarezKhodro from "./Pages/AvarezKhodro";
import AvarezService from "./Pages/AvarezService";
import Tarif from "./Pages/Tarif";
import Payment from "./Pages/PaySuccess";
import PaySuccess from "./Pages/PaySuccess";
import PayFailed from "./Pages/PayFailed";
export interface IRoutes {
  type?: string;
  name?: string;
  key?: string;
  route?: string;
  icon?: React.ReactNode;
  component?: React.ReactNode;
  collapse?: any;
  href?: any;
  dropdown?: any;
  level: string;
  childs?: any;
  childRoutes?: any;
  show: boolean;
}

const LogOut = () => {
  const navigate = useNavigate();
  useEffect(() => {
    localStorage.removeItem("_t");
    localStorage.removeItem("_et");
    eraseCookie("Authorization");
    WarningToaast("با موفقیت خارج شدید");
    navigate("/login", { replace: true });
    return () => {};
  }, []);

  return null;
};
const routes: IRoutes[] = [
  {
    type: "collapse",
    name: "صفحه اصلی",
    key: "",
    icon: <AccountBalanceIcon />,
    route: "/",
    component: <MainPage />,
    level: "authorize",
    show: true,
  },
  {
    type: "component",
    name: "ملک و مالک",
    key: "avareznosazi",
    icon: <KeyboardIcon />,
    route: "/avareznosazi/:id",
    component: <AvarezNosazi />,
    level: "authorize",
    show: true,
  },
  {
    type: "component",
    name: "پرداخت موفق",
    key: "paymentsuccess",
    icon: <KeyboardIcon />,
    route: "/paysuccess/:id",
    component: <PaySuccess/>,
    level: "",
    show: true,
  },
  {
    type: "component",
    name: "پرداخت ناموفق",
    key: "paymentfailed",
    icon: <KeyboardIcon />,
    route: "/payfailed/:id",
    component: <PayFailed/>,
    level: "",
    show: true,
  },
  {
    type: "component",
    name: "عوارض صنف",
    key: "avarezsenf",
    icon: <KeyboardIcon />,
    route: "/avarezsenf/:id",
    component: <AvarezSenf />,
    level: "authorize",
    show: true,
  },
  {
    type: "collapsechilds",
    name: "عوارض نوسازی",
    key: "nosazi",
    icon: <ReceiptLongIcon />,
    component: <Ghabz />,
    level: "authorize",
    show: true,
    childRoutes: ["melkmalek","gozareshkoli"],
    childs: [
      {
        type: "collapse",
        name: "ملک و مالک",
        key: "melkmalek",
        icon: <KeyboardIcon />,
        route: "/melkmalek",
        component: <MelkMalek />,
        level: "authorize",
        show: true,
      },
      {
        type: "collapse",
        name: "گزارش کلی",
        key: "gozareshkoli",
        icon: <KeyboardIcon />,
        route: "/gozareshkoli",
        component: <GozareshKoliAsnaf />,
        level: "authorize",
        show: true,
      },
    ],
  },
  {
    type: "collapsechilds",
    name: "عوارض کسب و پیشه",
    key: "kasbopishe",
    icon: <ReceiptLongIcon />,
    component: <Ghabz />,
    level: "authorize",
    show: true,
    childRoutes: ["maleksenf","asnaf"],
    childs: [
      {
        type: "collapse",
        name: "مالکین صنف",
        key: "maleksenf",
        icon: <KeyboardIcon />,
        route: "/maleksenf",
        component: <MalekSenf />,
        level: "authorize",
        show: true,
      },
      {
        type: "collapse",
        name: "اصناف",
        key: "asnaf",
        icon: <KeyboardIcon />,
        route: "/asnaf",
        component: <Asnaf />,
        level: "authorize",
        show: true,
      },
    ],
  },

  {
    type: "collapsechilds",
    name: "عوارض حمل و نقل",
    key: "vehicle",
    icon: <ReceiptLongIcon />,
    component: <Ghabz />,
    level: "authorize",
    show: true,
    childRoutes: ["vehicles","vehicleServices","avarezService","tarefeha"],
    childs: [
      {
        type: "collapse",
        name: "وسیله نقلیه ",
        key: "vehicles",
        icon: <KeyboardIcon />,
        route: "/vehicles",
        component: <Vehicles />,
        level: "authorize",
        show: true,
      },
      {
        type: "collapse",
        name: "نوع سرویس ",
        key: "avarezService",
        icon: <KeyboardIcon />,
        route: "/avarezService",
        component: <AvarezService />,
        level: "authorize",
        show: true,
      },
      {
        type: "collapse",
        name: "تعرفه ها ",
        key: "tarefeha",
        icon: <KeyboardIcon />,
        route: "/tarefeha",
        component: <Tarif />,
        level: "authorize",
        show: true,
      },
      {
        type: "collapse",
        name: "صدور قبض ",
        key: "avarezekhodro",
        icon: <KeyboardIcon />,
        route: "/avarezekhodro",
        component: <AvarezKhodro />,
        level: "authorize",
        show: true,
      },
    ],
  },
  {
    type: "collapse",
    name: "پارامتر ها",
    key: "params",
    icon: <KeyboardIcon />,
    route: "/params",
    component: <ParametrsPage />,
    level: "authorize",
    show: false,
  },

  {
    type: "collapse",
    name: "بانک",
    key: "billing",
    icon: <AccountBalanceIcon />,
    route: "/billing",
    component: <BankPage />,
    level: "authorize",
    show: true,
  },
  {
    type: "component",
    name: "عملیات بانک",
    key: "bankOperation",
    icon: <AccountBalanceIcon />,
    route: "/bankOperation",
    component: <AddOrEditBanks />,
    level: "authorize",
    show: true,
  },
  {
    type: "collapsechilds",
    name: "قبض",
    key: "allghabz",
    icon: <ReceiptLongIcon />,
    component: <Ghabz />,
    level: "authorize",
    childRoutes: ["ghabzes", "ghabzlist"],
    show: false,
    childs: [
      {
        name: "لیست قبوض",
        icon: <ReceiptLongIcon />,
        key: "ghabzlist",
        component: <GhabzList />,
        route: "/ghabzlist",
      },
      {
        name: "قبض جدید",
        icon: <ReceiptLongIcon />,
        key: "ghabzes",
        component: <Ghabz />,
        route: "/ghabzes",
      },
    ],
  },
  {
    type: "collapse",
    name: "مشترکین",
    key: "subscribers",
    icon: <ReceiptLongIcon />,
    route: "/subscribers",
    component: <Subscribers />,
    level: "authorize",
    show: false,
  },
  {
    type: "collapse",
    name: "قیمت منطقه ای",
    key: "subscribers",
    icon: <ReceiptLongIcon />,
    route: "/gheymatmanteghei",
    component: <GheymatManteghei />,
    level: "authorize",
    show: false,
  },
  {
    type: "component",
    name: "SubscribersDetail",
    key: "SubscribersDetail",
    icon: <WeekendIcon />,
    route: "/subscribers/:slug",
    component: <SubscribersDetail />,
    level: "authorize",
    show: false,
  },
  {
    type: "divider",
    key: "divider",
    level: "authorize",
    show: true,
  },
  {
    type: "collapse",
    name: "خروج",
    key: "profile",
    icon: <WeekendIcon />,
    route: "/logout",
    component: <LogOut />,
    level: "public",
    show: true,
  },
  {
    type: "component",
    name: "Login",
    key: "login",
    icon: <WeekendIcon />,
    route: "/login",
    component: <LoginComponnent />,
    level: "auth",
    show: true,
  },
  {
    type: "component",
    name: "PrintHtml",
    key: "PrintHtml",
    icon: <WeekendIcon />,
    route: "/PrintHtml",
    component: <PrintHtml />,
    level: "authorize",
    show: true,
  },
  {
    type: "component",
    name: "EditGhabz",
    key: "EditGhabz",
    icon: <WeekendIcon />,
    route: "/editghabz/:slug",
    component: <EditGhabz />,
    level: "authorize",
    show: true,
  },
  {
    type: "component",
    name: "notfound",
    key: "notfound",
    icon: <WeekendIcon />,
    route: "/notfound",
    component: <NotFound />,
    level: "public",
    show: true,
  },
];

export default routes;
